import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import "./Patient.css";
import ListView from "./partial/ListView";
import { appName } from "../../app.json";
import { useQuery } from "react-apollo";
import { GET_PATIENT_LIST } from "../../queries/patient.query";
import auth from "../../providers/Auth.Provider";
import Pagination from "../../partials/pagination";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import FabButton from "../../partials/Buttons/FabButton";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";
import LoadingSpinner from "../../partials/loading";

const View = ({ history }) => {
    const [page, setPage] = useState(1);
    const [limit] = useState(25);
    const [list] = useState(true);
    const { GetAuthenticatedStaff, GetToken, LogOut } = auth.authProvider;

    const {
        site: { id },
        admin,
    } = GetToken() && GetAuthenticatedStaff();

    const title = "Patients";

    const { loading, data, refetch, fetchMore } = useQuery(GET_PATIENT_LIST, {
        notifyOnNetworkStatusChange: false,
        onError: (e) => toast.error(CleanMessage(e.message)),
        variables: { limit, page, site: id },
    });

    EventEmitter.subscribe(EVENT_TARGET.PATIENT, () => refetch());

    useEffect(() => {
        fetchMore({
            variables: { page, limit, site: id },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return { GetPatients: fetchMoreResult.GetPatients };
            },
        });
    }, [page, limit, fetchMore, id]);

    if (!GetToken()) {
        LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${this.props.location.pathname}`,
                    state: { location: this.props.location },
                }}
            />
        );
    }
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-md-12">
                    <div>
                        {list && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body" style={{ minHeight: "480px" }}>
                                            <LoadingSpinner loading={loading} />
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    {data && (
                                                        <>
                                                            <thead className="fade-in">
                                                                <tr>
                                                                    <th className="center">Sn</th>
                                                                    <th className="center">Image</th>
                                                                    <th className="left"> Patient </th>
                                                                    <th className="center">
                                                                        <strong>CSN</strong>
                                                                    </th>
                                                                    <th className="text-center"> Gender </th>
                                                                    <th className="center">Birth Date</th>
                                                                    <th className="text-left">Date of Joining</th>
                                                                    <th className="text-center">Actions</th>
                                                                </tr>
                                                            </thead>
                                                        </>
                                                    )}
                                                    <tbody>
                                                        {data &&
                                                            data.GetPatients.docs.map((patient, index) => {
                                                                return <ListView key={index} history={history} patient={patient} listNo={index + 1} />;
                                                            })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {data && (
                            <div className="row fade-in">
                                <div className="col-md-12">
                                    <div className="card">
                                        <Pagination
                                            onPageClicked={(page) => {
                                                setPage(page);
                                            }}
                                            {...data.GetPatients}
                                            length={data && data.GetPatients.docs.length}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {admin && (
                <FabButton
                    title="New Patient"
                    onClick={() => {
                        history.push("/home/patient/create");
                    }}
                />
            )}
        </>
    );
};

export default View;
